import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { LogOut } from 'lucide-react';
import raahMark from '../assets/raah-mark.png';

export function Layout({ children }) {
  const { user, logout, isAuthenticated } = useAuth0();

  return (
    <div className="app-shell">
      <header className="topbar">
        <Link to="/dashboard" className="brand">
          <img src={raahMark} alt="" className="brand-mark" />
          <span className="brand-text">
            <span className="brand-name">WATT</span>
            <span className="brand-tagline">Web Access Tracking Terminal</span>
          </span>
        </Link>
        {isAuthenticated && (
          <div className="topbar-right">
            <span className="user-email">{user?.email}</span>
            <button
              className="btn btn-ghost"
              onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
            >
              <LogOut size={16} />
              Log out
            </button>
          </div>
        )}
      </header>
      <main className="app-main">{children}</main>
      <footer className="app-footer">
        <a href="https://raahtech.com" target="_blank" rel="noreferrer" className="footer-link">
          Powered by <span className="raah-brand">RAAH</span> Technologies
        </a>
      </footer>
    </div>
  );
}
